var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logos/Brand/DPD/Red/logoCubeRed"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1650_13154",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "boundingBox",
    x: 0.800781,
    y: 0.511719,
    width: 20.4002,
    height: 24.0002,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1650_13154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primaryCubeBlack",
    d: "M20.6169 5.70809L20.3354 5.8868C18.2932 7.08754 16.2565 8.29386 14.2088 9.48901C13.9657 9.59973 13.8224 9.858 13.8556 10.1257C13.8942 10.8405 13.8556 10.7512 14.4407 11.1198C14.6483 11.284 14.9378 11.2908 15.1527 11.1365C17.0293 10.0196 18.9169 8.90261 20.7935 7.78564L21.1357 7.59017C21.1398 7.6683 21.1398 7.7466 21.1357 7.82473V18.0505C21.143 18.3975 20.9486 18.7166 20.6389 18.8659L14.2916 22.6692C13.3699 23.2277 12.4426 23.7862 11.5319 24.3446C11.2091 24.5677 10.784 24.5677 10.4612 24.3446C7.42551 22.5128 4.38984 20.6959 1.35417 18.8939C0.99732 18.7108 0.780865 18.3319 0.80223 17.9277C0.80223 14.5768 0.80223 11.2426 0.80223 7.92526C0.80223 7.82473 0.80223 7.72979 0.80223 7.59017L1.1058 7.75772L9.74366 12.8399C9.94038 12.9265 10.0588 13.1323 10.0362 13.3481C10.0362 15.8278 10.0362 18.3019 10.0362 20.7815V21.0328C10.029 21.1984 10.1203 21.3523 10.268 21.4238L10.7316 21.6863C10.8775 21.7757 11.0604 21.7757 11.2063 21.6863L11.6478 21.4405C11.8069 21.3715 11.9047 21.2074 11.8907 21.0328C11.8907 20.9658 11.8907 20.8988 11.8907 20.8318V12.4099C11.8907 12.3317 11.8907 12.2591 11.8907 12.1809C11.896 12.0276 11.8146 11.8846 11.681 11.8123L10.98 11.399L1.64118 5.8868L1.35417 5.71367L1.58599 5.55171L10.417 0.670579C10.7552 0.458765 11.1827 0.458765 11.5209 0.670579C14.4738 2.31252 17.4156 3.92653 20.3575 5.55171L20.6169 5.70809Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.17f3e592e34d72b97e1fd2ea0863b578.svg";
export { ForwardRef as ReactComponent };